/* eslint-disable camelcase */
import { useDispatch } from 'react-redux';

import storeApplicationAction from 'Actions/application';
import { useGlobalQuery } from 'Hooks/useGlobalQuery';
import { PaymentChannel } from 'Models/Applications/Payment';
import { getApplication } from 'Services/Applications/Application';
import { PROTECTED_APPLICATION } from 'Utils/queries';
import { useEffect } from 'react';
import { tracker } from '@kueski-dev/web-observability';

interface Requirements {
  identity_verification?: {
    url: string,
    mode: 'redirect'
  };
  debit_card_registration?: {
    mode: 'redirect',
    scenario?: string
  };
  downpayment?: {
    scenario?: string;
  };
  select_deposit_card?: {
    mode: string,
    wallet?: {
      selected_account_details?: {
        last_4_digits: string,
        bank_account_type: string,
        bank_name: string
      }
    }
  };
}

interface RecurrenceByProduct {
  pay: boolean;
  cash: boolean;
}

interface Auth {
  bearer: string;
  domain: string;
}

export interface ProtectedApplication {
  application_process_id: string;
  customer_name: string;
  customer_email: string;
  status: 'loan' | 'filling' | 'scoring' | 'approving'; // TODO: Add more statuses
  recurrent: boolean;
  customer_id: string;
  product_id: string;
  reca: string;
  reason?: string;
  payment_type: string;
  channel: PaymentChannel;
  requirements: Requirements;
  recurrence_by_product: RecurrenceByProduct;
  auth: Auth;
}

type TUseProtectedApplication = {
  enabled?: boolean;
}

export default function useProtectedApplication({ enabled }: TUseProtectedApplication = {}) {
  const dispatch = useDispatch();
  const queryResult = useGlobalQuery<ProtectedApplication>(
    [PROTECTED_APPLICATION], getApplication, { enabled },
  );
  const { data: application } = queryResult;

  useEffect(() => {
    if (!application) return;
    const storeApplication = (params: object) => dispatch(storeApplicationAction(params));

    // TODO deprecate app stored in redux when all uses are migrated to useProtectedApplication
    storeApplication({
      applicationId: application.application_process_id,
      channel: application.channel,
      customerId: application.customer_id,
      customerName: application.customer_name,
      productType: application.payment_type,
    });

    tracker.identifyUser({
      email: application.customer_email,
      id: application.customer_id,
      name: application.customer_name,
    });
  }, [application]);
  return queryResult;
}
